(() => {
  const init = (root = document) => {
    root.querySelectorAll('.mo-search-window').forEach(modal => {
      if (modal.dataset.moSearchReady) return;
      modal.dataset.moSearchReady = 'true';
      const input = modal.querySelector('input[type="search"]');
      const form = input?.form;
      if (!input || !form) return;
      const update = () => {
        modal.toggleAttribute('data-mo-search-active', !!input.value.trim());
        const panel = modal.querySelector('.search-modal');
        if (panel) panel.scrollTop = 0;
      };
      input.addEventListener('input', update);
      input.addEventListener('search', update);
      input.addEventListener('focus', update);
      form.addEventListener('reset', () => setTimeout(update, 0));
      modal.addEventListener('click', event => {
        const shortcut = event.target.closest('[data-mo-search-term]');
        if (!shortcut) return;
        if (!modal.querySelector('predictive-search')) return;
        event.preventDefault();
        input.value = shortcut.dataset.moSearchTerm;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
      const details = modal.querySelector('details');
      const panel = modal.querySelector('.search-modal');
      const viewport = window.visualViewport;
      const mobile = window.matchMedia('(max-width: 989px)');
      const resize = () => {
        if (details.open && mobile.matches) panel.style.setProperty('--mo-search-viewport', `${viewport?.height || window.innerHeight}px`);
        else panel.style.removeProperty('--mo-search-viewport');
      };
      details.addEventListener('toggle', () => {
        resize();
        if (details.open) {
          panel.scrollTop = 0;
          viewport?.addEventListener('resize', resize);
        } else viewport?.removeEventListener('resize', resize);
      });
      mobile.addEventListener('change', resize);
      update();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

